import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_DURING_REGISTRATION,
  CONTRACT_TYPE_FOR_DEREGISTRATION,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  CONTRACT_TYPE_LEAD,
  CONTRACT_TYPE_LEASING,
  CONTRACT_TYPE_MANDATE,
  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
  CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
  CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT,
  CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_TYPE_TERMINAL,
  DICT_TYPE_POST_STATUS,
  DictService,
  POST_STATUS_PUBLISHED,
  POST_STATUS_SKETCH,
  POST_TAG_TYPE_DEPARTMENT_TYPE,
  POST_TAG_TYPE_INSURANCE_COMPANY,
  POST_TAG_TYPE_POST_TYPE,
  POST_TAG_TYPE_REMAINING
} from "../../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import moment from "moment/moment";
import {PostService} from "../../../../shared/services/post.service";
import {HttpErrorResponse} from "@angular/common/http";
import {Observable, of, ReplaySubject} from "rxjs";
import {Post} from "../../../../shared/interface/post";
import {delay, first, takeUntil, tap} from "rxjs/operators";
import {Tag} from "../../../../shared/interface/tag";
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {NgxImageCompressService} from "ngx-image-compress";
import {DOC_ORIENTATION} from "ngx-image-compress/lib/models/DOC_ORIENTATION";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {Attachments} from "../../../../shared/interface/attachments";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import * as uuid from 'uuid';
import {PostDetails} from "../../../../shared/interface/post-details";
import {TagService} from "../../../../shared/services/tag.service";
import {TagUsers} from "../../../../shared/interface/tag-users";
import {UsersDialogComponent} from "../../../../shared/components/users-dialog/users-dialog.component";
import {User} from "../../../../shared/interface/user";
import {validPhoneNumber} from "../../../../shared/validator/phone-validator";
import {validEmailAddress} from "../../../../shared/validator/email-validator";
import {UserService} from "../../../../shared/services/user.service";
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {PermissionTagsService} from "../../../../shared/services/permission-tags.service";
import {src} from "../../../../../environments/environment";

@Component({
  selector: 'app-post-add',
  templateUrl: './post-add.component.html',
  styleUrls: ['./post-add.component.scss']
})
export class PostAddComponent implements OnInit {

  @Input() maxSize = 2100000;
  @Input() postObject?: Post;
  @Input() post?: Observable<Post>;
  @Output() closeModification = new EventEmitter<any>();

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '400px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść ...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['fontName', 'inline-block'],
      [
        'insertVideo',
        'insertImage',
        'insertHorizontalRule'
      ]
    ]
  };

  postForm: FormGroup;
  todayDate: string;
  postNameControl: FormControl;
  publishingDepartmentControl: FormControl;
  typeControl: FormControl;
  tagsControl: FormControl;
  startAtControl: FormControl;
  endAtControl: FormControl;
  statusControl: FormControl;
  shortContentControl: FormControl;
  longContentControl: FormControl;
  ctaButtonControl: FormControl;
  ctaLinkControl: FormControl;
  ctaHeadlineControl: FormControl;
  ctaTextControl: FormControl;
  fileControl: FormControl;
  startsAtTimeControl: FormControl;
  endsAtTimeControl: FormControl;
  permissionRegionalControl: FormControl;
  permissionPartnerControl: FormControl;
  permissionPartnerCompetitionControl: FormControl;
  permissionOfwcaControl: FormControl;
  permissionOfwcaCompetitionControl: FormControl;
  permissionOfwcaProductControl: FormControl;
  permissionMultiAgencyProfitControl: FormControl;
  permissionRegistrationControl: FormControl;
  permissionRegistrationListControl: FormControl;
  permissionTagPartnerControl: FormControl;
  permissionContractTypeControl: FormControl;
  permissionIddTrainingStatusControl: FormControl;
  permissionTagControl: FormControl;
  fileShortControl: FormControl;
  contentShortControl: FormControl;
  fileLongControl: FormControl;
  contentLongControl: FormControl;
  fileAttachmentControl: FormControl;
  contentAttachmentControl: FormControl;
  tagsInsuranceControl: FormControl;
  tagsRemainingControl: FormControl;
  permissionContractAndControl: FormControl;
  permissionTagPartnerAndControl: FormControl;
  permissionEmployeeControl: FormControl;
  permissionDepartmentControl: FormControl;
  permissionDepartmentListControl: FormControl;
  ctaEndDateControl: FormControl;
  ctaExpiredTextControl: FormControl;
  cta = false;
  haveLongAttachment = false;
  haveShortAttachment = false;
  haveAttachmentAttachment = false;
  postAdd = false;
  postDetails: FormGroup[] = [];
  userFormArray: FormGroup[] = [];
  errors: any = {};
  header = null;
  initializeStart = false;
  contractOnlyKeys = [];
  fileShortEdit = false;
  competitionCtaControl: FormControl;
  permissionAsfPremiumControl: FormControl;
  permissionAsfControl: FormControl;
  permissionMultisferaControl: FormControl;

  readonly POST_TAG_TYPE_DEPARTMENT_TYPE = POST_TAG_TYPE_DEPARTMENT_TYPE;
  readonly POST_TAG_TYPE_POST_TYPE = POST_TAG_TYPE_POST_TYPE;
  readonly POST_TAG_TYPE_INSURANCE_COMPANY = POST_TAG_TYPE_INSURANCE_COMPANY;
  readonly POST_TAG_TYPE_REMAINING = POST_TAG_TYPE_REMAINING;
  readonly src = src;

  readonly PARTNER_TYPES = [
    CONTRACT_TYPE_PARTNERSHIP,
    CONTRACT_TYPE_PROFIT,
    CONTRACT_TYPE_TERMINAL,
    CONTRACT_TYPE_FRANCHISE,
    CONTRACT_TYPE_OCK,
    CONTRACT_TYPE_LEASING,
    CONTRACT_TYPE_LEAD,
    CONTRACT_TYPE_SELF_BILLING,
    CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
    CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  ];
  readonly OFWCA_TYPES = [
    CONTRACT_TYPE_MANDATE,
    CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
    CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
    CONTRACT_TYPE_MANDATE_STUDENT
  ];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private postService: PostService,
    private imageCompress: NgxImageCompressService,
    private tagService: TagService,
    private permissionTagsService: PermissionTagsService,
    private userService: UserService,
  ) {
    this.postForm = fb.group({
      postName: this.postNameControl = this.fb.control('', [Validators.required]),
      publishingDepartment: this.publishingDepartmentControl = this.fb.control('', [Validators.required]),
      type: this.typeControl = this.fb.control('', [Validators.required]),
      tags: this.tagsControl = this.fb.control([]),
      tagsRemaining: this.tagsRemainingControl = this.fb.control([]),
      tagsInsurance: this.tagsInsuranceControl = this.fb.control([]),
      startAt: this.startAtControl = this.fb.control('', [Validators.required]),
      endAt: this.endAtControl = this.fb.control(''),
      shortContent: this.shortContentControl = this.fb.control('', [ Validators.maxLength(500)] ),
      longContent: this.longContentControl = this.fb.control(''),
      ctaButton: this.ctaButtonControl = this.fb.control(''),
      ctaLink: this.ctaLinkControl = this.fb.control(''),
      competitionCta: this.competitionCtaControl =  this.fb.control(false),
      ctaHeadline: this.ctaHeadlineControl = this.fb.control(''),
      ctaText: this.ctaTextControl = this.fb.control(''),
      status: this.statusControl = this.fb.control(''),
      startsAtTime: this.startsAtTimeControl = fb.control('06:00'),
      endsAtTime: this.endsAtTimeControl = fb.control('23:59' ),
      permissionRegional: this.permissionRegionalControl = this.fb.control([]),
      permissionPartner: this.permissionPartnerControl = this.fb.control(true),
      permissionOfwca: this.permissionOfwcaControl = this.fb.control(true),
      permissionPartnerCompetition: this.permissionPartnerCompetitionControl = this.fb.control(false),
      permissionOfwcaCompetition: this.permissionOfwcaCompetitionControl = this.fb.control(false),
      permissionOfwcaProduct: this.permissionOfwcaProductControl = this.fb.control(false),
      permissionMultiAgencyProfit: this.permissionMultiAgencyProfitControl = this.fb.control(false),
      permissionEmployee: this.permissionEmployeeControl = this.fb.control(false),
      permissionRegistration: this.permissionRegistrationControl = this.fb.control(false),
      permissionRegistrationList: this.permissionRegistrationListControl = this.fb.control([]),
      permissionTagPartner: this.permissionTagPartnerControl = this.fb.control([]),
      permissionDepartment: this.permissionDepartmentControl = this.fb.control(false),
      permissionDepartmentList: this.permissionDepartmentListControl = this.fb.control([]),
      permissionContractType: this.permissionContractTypeControl = this.fb.control([]),
      permissionIddTrainingStatus: this.permissionIddTrainingStatusControl = this.fb.control([]),
      permissionTag: this.permissionTagControl = this.fb.control([]),
      fileShort: this.fileShortControl = fb.control([]),
      filenameShort: fb.control(''),
      contentShort: this.contentShortControl = fb.control(''),
      fileLong: this.fileLongControl = fb.control(''),
      filenameLong: fb.control(''),
      contentLong: this.contentLongControl = fb.control(''),
      fileAttachment: this.fileAttachmentControl = fb.control([]),
      filenameAttachment: fb.control(''),
      contentAttachment: this.contentAttachmentControl = fb.control(''),
      permissionContractAnd: this.permissionContractAndControl = this.fb.control(''),
      permissionTagPartnerAnd:  this.permissionTagPartnerAndControl = this.fb.control(''),
      postDetails:  fb.array(this.postDetails),
      users: fb.array(this.userFormArray),
      ctaEndDate: this.ctaEndDateControl = fb.control(''),
      ctaExpiredText: this.ctaExpiredTextControl = fb.control(''),
      permissionAsfPremium: this.permissionAsfPremiumControl = this.fb.control(false),
      permissionAsf: this.permissionAsfControl = this.fb.control(false),
      permissionMultisfera: this.permissionMultisferaControl = this.fb.control(false),
    });
    this.startAtControl.setValue(moment());
    this.permissionTagPartnerControl.disable();
    this.permissionIddTrainingStatusControl.disable();
    this.permissionTagPartnerAndControl.disable();
    this.permissionTagsService.loadDict();
  }

  ngOnInit(): void {

    if (this.post) {
      this.post
        .pipe(takeUntil(this.destroyed$))
        .subscribe((post: Post) => {
          this.postObject = post;
          this.initialize(post);
        });
    }

    this.fileShortControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: File[]) => {
        this.fileShortEdit = false;
        if ( file) {
        file.forEach((fileToRead: File) => {
          this.postForm.get('filenameShort').setValue(this.postForm.get('filenameShort').value +
            (this.postForm.get('filenameShort').value ? ', ' : '') +
            fileToRead.name);
          this.postForm.get('contentShort').reset('');
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);

          //
          reader.onload = () => {
            const image = reader.result.toString();
            const orientation: DOC_ORIENTATION = 3;
            this.imageCompress
              .compressFile(image, orientation, 90, 80, 1024, 1024) // 50% ratio, 50% quality
              .then(compressedImage => {
                this.postForm.get('contentShort').setValue(
                  this.postForm.get('contentShort').value +
                  (this.postForm.get('contentShort').value ? ', ' : '') +
                  (/base64,(.+)/.exec(compressedImage)[1])
                );
              });
          };
        });
        }
      });

    this.permissionPartnerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!this.initializeStart) {
          if (!this.permissionTagControl.value || this.permissionTagControl.value.length === 0) {
            if (val) {
              if (this.permissionOfwcaControl.value) {
                this.permissionTagPartnerControl.reset();
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionContractTypeControl.reset();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.enable();
                this.permissionRegionalControl.enable();
              } else {
                this.permissionTagPartnerControl.enable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionTagPartnerAndControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionOfwcaCompetitionControl.setValue(false);
                this.permissionOfwcaProductControl.setValue(false);
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.PARTNER_TYPES;
              }
            } else {
              if (!this.permissionOfwcaControl.value) {
                this.permissionTagPartnerControl.reset();
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.setValue(false);
                this.permissionPartnerCompetitionControl.disable();
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionContractTypeControl.reset();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.reset();
                this.permissionRegionalControl.reset();
                this.permissionRegistrationControl.disable();
                this.permissionRegionalControl.disable();
                this.permissionOfwcaCompetitionControl.setValue(false);
                this.permissionOfwcaProductControl.setValue(false);
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
              } else {
                this.permissionTagPartnerControl.reset();
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.setValue(false);
                this.permissionPartnerCompetitionControl.disable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionIddTrainingStatusControl.enable();
                this.permissionOfwcaCompetitionControl.enable();
                this.permissionOfwcaProductControl.enable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.OFWCA_TYPES;
              }

            }
            if (this.permissionMultiAgencyProfitControl.value) {
              this.permissionRegionalControl.reset();
              this.permissionRegionalControl.disable();
            }
          }
        } else {
            if (val) {
              if (this.permissionOfwcaControl.value) {
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.enable();
                this.permissionRegionalControl.enable();
              } else {
                this.permissionTagPartnerControl.enable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionTagPartnerAndControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.PARTNER_TYPES;
              }
            } else {
              if (!this.permissionOfwcaControl.value) {
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.disable();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.disable();
                this.permissionRegionalControl.disable();
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
              } else {
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.disable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionIddTrainingStatusControl.enable();
                this.permissionOfwcaCompetitionControl.enable();
                this.permissionOfwcaProductControl.enable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.OFWCA_TYPES;
              }
            }
        }
      });

    this.publishingDepartmentControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: Tag) => {
        this.tagService.get(val).subscribe((tag: Tag) => {
         if (!this.initializeStart)
         {
            this.userFormArray = [];
           this.header = tag.header;
           tag.users.forEach((users: TagUsers) =>
             this.addUsers(false, users.usersUuid, users.usersName,
               users.usersPosition, users.usersPhone, users.usersEmail));
          }else {
           this.initializeStart = false;
         }

        }, (error: HttpErrorResponse) => {
          this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
            duration: 2000
          });
        });
      });

    this.permissionEmployeeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!val){
          this.permissionDepartmentControl.setValue(false);
          this.permissionDepartmentListControl.setValue([]);
        }

      });

    this.permissionOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!this.initializeStart){
          if (!this.permissionTagControl.value  || this.permissionTagControl.value.length === 0) {
            if (val) {
              if (this.permissionPartnerControl.value) {
                this.permissionTagPartnerControl.reset();
                this.permissionTagPartnerControl.disable();
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionOfwcaCompetitionControl.setValue(false);
                this.permissionOfwcaProductControl.setValue(false);
                this.permissionOfwcaCompetitionControl.enable();
                this.permissionOfwcaProductControl.enable();
                this.permissionContractTypeControl.reset();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.enable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionRegionalControl.enable();
              } else {
                this.permissionIddTrainingStatusControl.enable();
                this.permissionOfwcaCompetitionControl.enable();
                this.permissionOfwcaProductControl.enable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionPartnerCompetitionControl.setValue(false);
                this.permissionPartnerCompetitionControl.disable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.OFWCA_TYPES;
              }
            } else {
              if (!this.permissionPartnerControl.value) {
                this.permissionTagPartnerControl.reset();
                this.permissionTagPartnerControl.disable();
                this.permissionPartnerCompetitionControl.setValue(false);
                this.permissionPartnerCompetitionControl.disable();
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionOfwcaCompetitionControl.setValue(false);
                this.permissionOfwcaProductControl.setValue(false);
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
                this.permissionContractTypeControl.reset();
                this.permissionContractTypeControl.disable();
                this.permissionContractAndControl.disable();
                this.permissionTagPartnerAndControl.disable();
                this.permissionRegistrationControl.reset();
                this.permissionRegionalControl.reset();
                this.permissionRegistrationControl.disable();
                this.permissionRegionalControl.disable();
              } else {
                this.permissionIddTrainingStatusControl.reset();
                this.permissionIddTrainingStatusControl.disable();
                this.permissionOfwcaCompetitionControl.setValue(false);
                this.permissionOfwcaProductControl.setValue(false);
                this.permissionOfwcaCompetitionControl.disable();
                this.permissionOfwcaProductControl.disable();
                this.permissionContractTypeControl.enable();
                this.permissionContractAndControl.enable();
                this.permissionTagPartnerAndControl.enable();
                this.permissionTagPartnerControl.enable();
                this.permissionPartnerCompetitionControl.enable();
                this.permissionRegistrationControl.enable();
                this.permissionRegionalControl.enable();
                this.contractOnlyKeys = this.PARTNER_TYPES;
              }
            }
            if (this.permissionMultiAgencyProfitControl.value)
            {
              this.permissionRegionalControl.reset();
              this.permissionRegionalControl.disable();
            }
          }
        } else{
          if (val) {
            if (this.permissionPartnerControl.value) {
              this.permissionTagPartnerControl.disable();
              this.permissionIddTrainingStatusControl.disable();
              this.permissionOfwcaCompetitionControl.enable();
              this.permissionOfwcaProductControl.enable();
              this.permissionContractTypeControl.disable();
              this.permissionContractAndControl.disable();
              this.permissionTagPartnerAndControl.disable();
              this.permissionRegistrationControl.enable();
              this.permissionPartnerCompetitionControl.enable();
              this.permissionRegionalControl.enable();
            } else {
              this.permissionIddTrainingStatusControl.enable();
              this.permissionOfwcaCompetitionControl.enable();
              this.permissionOfwcaProductControl.enable();
              this.permissionContractTypeControl.enable();
              this.permissionContractAndControl.enable();
              this.permissionRegistrationControl.enable();
              this.permissionPartnerCompetitionControl.disable();
              this.permissionRegionalControl.enable();
              this.contractOnlyKeys = this.OFWCA_TYPES;
            }
          } else {
            if (!this.permissionPartnerControl.value) {
              this.permissionTagPartnerControl.disable();
              this.permissionPartnerCompetitionControl.disable();
              this.permissionIddTrainingStatusControl.disable();
              this.permissionOfwcaCompetitionControl.disable();
              this.permissionOfwcaProductControl.disable();
              this.permissionContractTypeControl.disable();
              this.permissionContractAndControl.disable();
              this.permissionTagPartnerAndControl.disable();
              this.permissionRegistrationControl.disable();
              this.permissionRegionalControl.disable();
            } else {
              this.permissionIddTrainingStatusControl.disable();
              this.permissionOfwcaCompetitionControl.disable();
              this.permissionOfwcaProductControl.disable();
              this.permissionContractTypeControl.enable();
              this.permissionContractAndControl.enable();
              this.permissionTagPartnerAndControl.enable();
              this.permissionTagPartnerControl.enable();
              this.permissionPartnerCompetitionControl.enable();
              this.permissionRegistrationControl.enable();
              this.permissionRegionalControl.enable();
              this.contractOnlyKeys = this.PARTNER_TYPES;
            }
          }
        }
      });

    this.permissionRegistrationControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!this.initializeStart){
            if (!this.permissionTagControl.value) {
              if (val) {
                this.permissionRegistrationListControl.enable();
              } else {
                this.permissionRegistrationListControl.reset();
                this.permissionRegistrationListControl.disable();
              }
            }
          }
      });

    this.permissionDepartmentControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (!this.initializeStart){
            if (val) {
              this.permissionDepartmentListControl.enable();
            } else {
              this.permissionDepartmentListControl.reset();
              this.permissionDepartmentListControl.disable();
            }
        }
      });

    this.fileLongControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: File[]) => {
        if ( file) {
        file.forEach((fileToRead: File) => {
          this.postForm.get('filenameLong').setValue(this.postForm.get('filenameLong').value +
            (this.postForm.get('filenameLong').value ? ', ' : '') +
            fileToRead.name);
          this.postForm.get('contentLong').reset('');
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            const image = reader.result.toString();
            const orientation: DOC_ORIENTATION = 3;
            this.imageCompress
              .compressFile(image, orientation, 90, 80, 2500, 2500) // 50% ratio, 50% quality
              .then(compressedImage => {
                this.postForm.get('contentLong').setValue(
                  this.postForm.get('contentLong').value +
                  (this.postForm.get('contentLong').value ? ', ' : '') +
                  (/base64,(.+)/.exec(compressedImage)[1])
                );
              });
          };
        });
        }
      });

    this.fileAttachmentControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: File[]) => {
        if ( file) {
          file.forEach((fileToRead: File) => {
            this.postForm.get('filenameAttachment').setValue(this.postForm.get('filenameAttachment').value +
              (this.postForm.get('filenameAttachment').value ? ', ' : '') +
              fileToRead.name);
            this.postForm.get('contentAttachment').reset('');
            const reader = new FileReader();
            reader.readAsDataURL(fileToRead);
            reader.onload = () => {
              this.postForm.get('contentAttachment').setValue(
                this.postForm.get('contentAttachment').value +
                (this.postForm.get('contentAttachment').value ? ', ' : '') +
                (/base64,(.+)/.exec(reader.result.toString())[1])
              );
            };
          });
        }
      });

    this.ctaLinkControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: string) => {
        if ( value ) {
          this.ctaLinkControl.clearValidators();
          this.ctaButtonControl.clearValidators();
          this.ctaLinkControl.setValidators([Validators.required]);
          this.ctaButtonControl.setValidators([Validators.required]);
          this.cta = true;
        } else if (!this.ctaButtonControl.value && !this.competitionCtaControl.value) {
          this.cta = false;
          this.ctaLinkControl.clearValidators();
          this.ctaButtonControl.clearValidators();

        }
      });

    this.competitionCtaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: boolean) => {
        if (!this.initializeStart) {
          if (value) {
            this.ctaLinkControl.reset();
            this.ctaEndDateControl.reset();
          } else {
            this.ctaLinkControl.clearValidators();
            this.ctaButtonControl.clearValidators();
          }
        }
        if (value) {
          this.ctaLinkControl.setValidators([Validators.required]);
          this.ctaButtonControl.setValidators([Validators.required]);
          this.cta = true;
        } else  {
          this.cta = false;
          if (!this.initializeStart) {
            this.ctaButtonControl.reset();
            this.ctaLinkControl.reset();
          }

        }
      });

    this.ctaButtonControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: string) => {
        if ( value  ) {
          this.ctaLinkControl.clearValidators();
          this.ctaButtonControl.clearValidators();
          this.ctaLinkControl.setValidators([Validators.required]);
          this.ctaButtonControl.setValidators([Validators.required]);
          this.cta = true;
        } else if (!this.ctaLinkControl.value && !this.competitionCtaControl.value) {
          this.cta = false;
          this.ctaLinkControl.clearValidators();
          this.ctaButtonControl.clearValidators();
          // this.ctaLinkControl.setValidators([]);
          // this.ctaButtonControl.setValidators([]);
        }
      });

    this.ctaEndDateControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value) => {
        if (value) {
          this.ctaExpiredTextControl.enable();
          this.ctaExpiredTextControl.setValidators([Validators.required]);
        } else {
          this.ctaExpiredTextControl.clearValidators();
          this.ctaExpiredTextControl.reset();
          this.ctaExpiredTextControl.disable();
        }
      });

    this.permissionOfwcaCompetitionControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: boolean) => {
        if ( value && !this.permissionTagControl.value) {
          this.permissionOfwcaProductControl.setValue(false);
        }
      });

    this.permissionOfwcaProductControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: boolean) => {
        if ( value  ) {
          this.permissionOfwcaCompetitionControl.setValue(false);
        }
      });

    this.permissionMultiAgencyProfitControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value: boolean) => {
        if (!this.initializeStart){
          if (value && !this.permissionTagControl.value) {
            this.permissionRegionalControl.reset();
            this.permissionRegionalControl.disable();
          } else if (!value && !this.permissionTagControl.value) {
            this.permissionRegionalControl.reset();
            this.permissionRegionalControl.enable();
          }
        }
      });

    this.permissionTagControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((value) => {
        if ( !this.initializeStart ) {
          if (value && value.length > 0) {
            this.permissionPartnerControl.reset();
            this.permissionOfwcaControl.reset();
            this.permissionPartnerControl.setValue(true);
            this.permissionOfwcaControl.setValue(true);
            this.permissionPartnerCompetitionControl.reset();
            this.permissionOfwcaCompetitionControl.reset();
            this.permissionOfwcaProductControl.reset();
            this.permissionRegionalControl.reset();
            this.permissionContractTypeControl.reset();
            this.permissionTagPartnerControl.reset();
            this.permissionIddTrainingStatusControl.reset();
            this.permissionContractAndControl.reset();
            this.permissionTagPartnerAndControl.reset();
            this.permissionMultiAgencyProfitControl.reset();
            // this.permissionPartnerControl.disable();
            // this.permissionOfwcaControl.disable();
            this.permissionRegistrationControl.reset();
            this.permissionRegistrationListControl.reset();
            this.permissionAsfPremiumControl.reset();
            this.permissionAsfControl.reset();
            this.permissionMultisferaControl.reset();
            this.permissionPartnerCompetitionControl.disable();
            this.permissionOfwcaCompetitionControl.disable();
            this.permissionOfwcaProductControl.disable();
            this.permissionRegionalControl.disable();
            this.permissionContractTypeControl.disable();
            this.permissionTagPartnerControl.disable();
            this.permissionIddTrainingStatusControl.disable();
            this.permissionContractAndControl.disable();
            this.permissionTagPartnerAndControl.disable();
            this.permissionRegistrationControl.disable();
            this.permissionRegistrationListControl.disable();
            this.permissionMultiAgencyProfitControl.disable();
            this.permissionAsfPremiumControl.disable();
            this.permissionAsfControl.disable();
            this.permissionMultisferaControl.disable();
          } else {
            this.permissionRegionalControl.enable();
            this.permissionPartnerControl.setValue(true);
            this.permissionOfwcaControl.setValue(true);
            this.permissionPartnerCompetitionControl.enable();
            this.permissionOfwcaCompetitionControl.enable();
            this.permissionOfwcaProductControl.enable();
            this.permissionRegionalControl.enable();
            this.permissionContractTypeControl.enable();
            this.permissionTagPartnerControl.enable();
            this.permissionIddTrainingStatusControl.enable();
            this.permissionContractAndControl.enable();
            this.permissionTagPartnerAndControl.enable();
            this.permissionRegistrationControl.enable();
            this.permissionRegistrationListControl.enable();
            this.permissionMultiAgencyProfitControl.enable();
            this.permissionAsfPremiumControl.enable();
            this.permissionAsfControl.enable();
            this.permissionMultisferaControl.enable();
          }
          if (this.permissionMultiAgencyProfitControl.value)
          {
            this.permissionRegionalControl.reset();
            this.permissionRegionalControl.disable();
          }
        } else {
          if (value && value.length > 0) {
            this.permissionPartnerCompetitionControl.disable();
            this.permissionOfwcaCompetitionControl.disable();
            this.permissionOfwcaProductControl.disable();
            this.permissionRegionalControl.disable();
            this.permissionContractTypeControl.disable();
            this.permissionTagPartnerControl.disable();
            this.permissionIddTrainingStatusControl.disable();
            this.permissionContractAndControl.disable();
            this.permissionTagPartnerAndControl.disable();
            this.permissionRegistrationControl.disable();
            this.permissionRegistrationListControl.disable();
            this.permissionMultiAgencyProfitControl.disable();
            this.permissionAsfPremiumControl.disable();
            this.permissionAsfControl.disable();
            this.permissionMultisferaControl.disable();
          }
          if (this.permissionMultiAgencyProfitControl.value)
          {
            this.permissionRegionalControl.disable();
          }

        }
      });


  }

  initialize(post: Post): void {
    of(post)
      .pipe(
        delay(0),
        tap(() => {
          this.fileShortEdit = true;
          this.initializeStart = true;
          this.postForm.reset({
            postName: post.postName,
            publishingDepartment: post.publishingDepartment.id,
            type: post.type.id,
            tags: post.tags.map((tag: Tag) => tag.id),
            tagsRemaining: post.tags.filter((tag: Tag) => tag.type.key === POST_TAG_TYPE_REMAINING).map((tag: Tag) => tag.id),
            tagsInsurance: post.tags.filter((tag: Tag) => tag.type.key === POST_TAG_TYPE_INSURANCE_COMPANY).map((tag: Tag) => tag.id),
            startAt:  moment(post.startAt),
            endAt: moment(post.endAt),
            shortContent: post.shortContent,
            longContent: post.longContent,
            competitionCta: post.competitionCta,
            ctaHeadline: post.ctaHeadline,
            ctaText: post.ctaText,
            status:  post.status.id,
            permissionRegional: post.permissionRegional,
            permissionPartner: post.permissionPartner,
            permissionOfwca: post.permissionOfwca,
            permissionTagPartner: post.permissionTagPartner,
            permissionContractType: post.permissionContractType,
            permissionIddTrainingStatus: post.permissionIddTrainingStatus,
            permissionTag: post.permissionTag,
            permissionPartnerCompetition: post.permissionPartnerCompetition,
            permissionOfwcaCompetition: post.permissionOfwcaCompetition,
            permissionOfwcaProduct: post.permissionOfwcaProduct,
            permissionMultiAgencyProfit: post.permissionMultiAgencyProfit,
            filenameShort: '',
            contentShort: '',
            fileLong: [],
            filenameLong: '',
            contentLong: '',
            fileAttachment: [],
            filenameAttachment: '',
            fileShort: [] ,
            contentAttachment: '',
            permissionContractAnd: post.permissionContractAnd,
            permissionTagPartnerAnd:  post.permissionTagPartnerAnd,
            permissionRegistrationList: post.permissionRegistrationList,
            permissionRegistration: post.permissionRegistration,
            permissionDepartment: post.permissionDepartment,
            permissionDepartmentList: post.permissionDepartmentList,
            permissionEmployee: post.permissionEmployee,
            ctaEndDate: post.ctaEndDate,
            ctaExpiredText: post.ctaExpiredText,
            ctaLink:  post.ctaLink,
            ctaButton: post.ctaButton,
            permissionAsfPremium: post.permissionAsfPremium,
            permissionAsf: post.permissionAsf,
            permissionMultisfera: post.permissionMultisfera,
          });
          post.postDetails.sort(  (a, b) => a.postDetailIndex - b.postDetailIndex );


          post.postDetails.forEach((details: PostDetails) => this.addPostDetails(
            details.postDetailType, details.postDetailUuid, details.postDetailCtaButton, details.postDetailCtaLink,
              details.postDetailCtaHeadline, details.postDetailCtaText, null, details.postDetailFilename,
              details.postDetailFileLocation, details.postDetailText, details.postDetailIndex, details.postTableColumn,
              details.postDetailTextSecond,  details.postDetailTextThird, false, details.postDetailMovieLink),
          );

          post.users
            .forEach((user: TagUsers) => {
              this.addUsers(false, user.usersUuid, user.usersName,
                user.usersPosition, user.usersPhone, user.usersEmail);
            });

          post.attachments.forEach((attachment: Attachments) => {
            if (attachment.type.key === 'short'){
              this.haveShortAttachment = true;
            }
            if (attachment.type.key === 'long'){
              this.haveLongAttachment = true;
            }
            if (attachment.type.key === 'attachment'){
              this.haveAttachmentAttachment = true;
            }
          });
            this.startsAtTimeControl.setValue(this.postForm?.get('startAt')?.value?.format('HH:mm'));
            if (post.endAt) {
              this.endsAtTimeControl.setValue(this.postForm?.get('endAt')?.value?.format('HH:mm'));
            } else  {
              this.postForm?.get('endAt').setValue(null);
              this.endsAtTimeControl.setValue('23:59');
            }
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  cancel(): void {
   if (!this.postObject) {
      this.router.navigate(['/asf360/aktualnosci']);
    } else {
      this.closeModification.emit();
    }
  }

  sendForm(published: boolean): void {
    if (this.postForm.get('fileShort').value.length === 0 ) {
      this.postForm.get('filenameShort').setValue(null);
      this.postForm.get('contentShort').setValue(null);
    }
    if (this.postForm.get('fileAttachment').value.length === 0 ) {
      this.postForm.get('filenameAttachment').setValue(null);
      this.postForm.get('contentAttachment').setValue(null);
    }

    this.updateUsersFormArray();
    this.postAdd = true;
    const formData: any = {...this.postForm.value};

    if (this.startAtControl.value )
    {
      formData.startAt = moment(this.startAtControl.value.format('YYYY-MM-DD')
        +  this.startsAtTimeControl.value, 'YYYY-MM-DDHH:mm');
      formData.startAt.utc();
    }
    if (this.endAtControl.value )
    {
      if (!this.endsAtTimeControl.value ){
        this.endsAtTimeControl.setValue('23:59');
      }
      formData.endAt = moment(this.endAtControl.value.format('YYYY-MM-DD')
        +  this.endsAtTimeControl.value, 'YYYY-MM-DDHH:mm');
      formData.endAt.utc();
    }


    if (!this.postForm.valid) {
      this.postForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      this.postAdd = false;
      return;
    }
    if (published)
    {
      this.dictService.getId(POST_STATUS_PUBLISHED, DICT_TYPE_POST_STATUS)
        .subscribe((dictId: number) => formData.status = dictId);
    } else {
      this.dictService.getId(POST_STATUS_SKETCH, DICT_TYPE_POST_STATUS)
        .subscribe((dictId: number) => formData.status = dictId);
    }
    formData.tags = this.tagsInsuranceControl.value.concat(this.tagsRemainingControl.value);
    this.postService.send(formData,this.postObject ? this.postObject.uuid : null )
      .pipe(
        first()
     )
      .subscribe((response: Uuid) => {
        this.snack.open(this.postObject ? 'Pomyślnie zaktualizowano post' : 'Pomyślnie utworzono post', '', {
          duration: 2000,
        });
        this.postAdd = false;
        if (!this.postObject  ) {
          this.router.navigate(['/asf360/aktualnosci/szczegoly/', response.uuid]);
        } else {
          this.closeModification.emit();
        }

      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania postu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.postAdd = false;
   });
  }

  deleteAttachment(attachment: Attachments): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć załącznik?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.postService.deleteAttachment(attachment.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto załącznik', '', {duration: 2000});
          });
      }
    });
  }

  downloadAttachment(attachment: Attachments): void {
    this.postService.downloadAttachment(attachment.uuid);
  }

  onPaste(event: ClipboardEvent, short: boolean) {
    event.preventDefault();

    const clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text') || '';

    const plainText = pastedText.replace(/<\/?[^>]+(>|$)/g, '');

    const currentValue = this.shortContentControl.value || '';

    const availableSpace = 500 - currentValue.length;

    const textToInsert = plainText.substring(0, availableSpace);
    if (short){
      document.execCommand('insertText', false, textToInsert);
    }else
    {
      document.execCommand('insertText', false, plainText);
    }
  }

  addPostDetails(postDetailType: string,
                 postDetailUuid?: string,
                 postDetailCtaButton?: string,
                 postDetailCtaLink?: string,
                 postDetailCtaHeadline?: string,
                 postDetailCtaText?: string,
                 postDetailContent?: string,
                 postDetailFilename?: string,
                 postDetailFileLocation?: string,
                 postDetailText?: string,
                 postDetailIndex?: number,
                 postTableColumn?: number,
                 postDetailTextSecond?: string,
                 postDetailTextThird?: string,
                 edit = true,
                 postDetailMovieLink?: string,
  ): void {
    switch (postDetailType) {
      case 'TEXT':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postDetailText: this.fb.control(postDetailText ?? ''),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),
        }));
        break;
      case 'ATTACHMENT':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postDetailContent: this.fb.control(postDetailContent ?? ''),
          postDetailFilename: this.fb.control(postDetailFilename ?? '',[Validators.required]),
          postDetailFileLocation: this.fb.control(postDetailFileLocation ?? ''),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),
          edit: this.fb.control(edit),
        }));
        break;
      case 'GRAPHICS':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postDetailContent: this.fb.control(postDetailContent ?? ''),
          postDetailFilename: this.fb.control(postDetailFilename ?? '',[Validators.required]),
          postDetailFileLocation: this.fb.control(postDetailFileLocation ?? ''),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),
          edit: this.fb.control(false),
          postDetailCtaLink: this.fb.control(postDetailCtaLink ?? ''),
        }));
        break;
      case 'CTA':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postDetailCtaButton: this.fb.control(postDetailCtaButton ?? '', [Validators.required]),
          postDetailCtaLink: this.fb.control(postDetailCtaLink ?? '', [Validators.required]),
          postDetailCtaHeadline: this.fb.control(postDetailCtaHeadline ?? ''),
          postDetailCtaText: this.fb.control(postDetailCtaText ?? ''),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),

        }));
        break;
      case 'TABLE':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postTableColumn: this.fb.control(postTableColumn ?? 2),
          postDetailText: this.fb.control(postDetailText ?? ''),
          postDetailTextSecond: this.fb.control(postDetailTextSecond ?? ''),
          postDetailTextThird: this.fb.control(postDetailTextThird ?? ''),
        }));
        break;
      case 'MOVIE':
        this.postDetails.push(this.fb.group({
          postDetailUuid: this.fb.control(postDetailUuid ?? uuid.v4(), [Validators.required]),
          postDetailIndex: this.fb.control(  postDetailIndex ?? this.postDetails.length ),
          postDetailType: this.fb.control(postDetailType, [Validators.required]),
          postDetailMovieLink: this.fb.control(postDetailMovieLink ?? ''),
        }));
        break;
      default:
    }
    this.refreshPostDetailsControl();
  }

  drop(event: CdkDragDrop<any[]>) {
    this.postDetails[event.previousIndex].get('postDetailIndex').setValue(event.currentIndex);
    this.postDetails[event.currentIndex].get('postDetailIndex').setValue(event.previousIndex);
    moveItemInArray(this.postDetails, event.previousIndex, event.currentIndex);
    this.refreshPostDetailsControl();
  }

  refreshPostDetailsControl(): void {
    this.postForm.setControl('postDetails', this.fb.array( this.postDetails));
  }

  removePostDetailsControl(i: number): void {
    this.postDetails.splice(i, 1);
    for ( let j = i; j < this.postDetails.length; j++) {
      this.postDetails[j].get('postDetailIndex').setValue(this.postDetails[j].get('postDetailIndex').value - 1);
    }
    this.refreshPostDetailsControl();
  }

  onFileChange(event: any, index: number) {
    this.postDetails[index].get('postDetailContent').setValue(event['base64']);
    this.postDetails[index].get('postDetailFilename').setValue( event['filename']);
    this.postDetails[index].get('edit').setValue( true);

  }

  addUsers(dialog= false, usersUuid?: string, usersName?: string, usersPosition?: string, usersPhone?: string, usersEmail?: string): void {
    if (dialog){
      const dialogRef = this.dialog.open(UsersDialogComponent, {
        width: '500px',
        data: {text: 'Wybierz użytkownika: '},
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const exists = this.userFormArray.some((user: FormGroup) => user.get('usersUuid')?.value === result);

          if (exists) {
            this.snack.open('Wybrany użytkownik już jest dodany', '', {
              duration: 2000
            });
            this.updateUsersFormArray();
            return;
          }
          this.userService.get(result).subscribe((user: User) => {
            this.userFormArray.push(this.fb.group({
              usersUuid:  this.fb.control(user.uuid || '', [Validators.required]),
              usersName:  this.fb.control(user.firstName + ' ' + user.lastName || '', [Validators.required]),
              usersPosition:  this.fb.control(user.position || ''),
              usersPhone:  this.fb.control(user.phone || '', [Validators.required, validPhoneNumber()]),
              usersEmail:  this.fb.control(user.email || '', [Validators.required, validEmailAddress()]),
            }));
          }, (error: HttpErrorResponse) => {
            this.snack.open('Nie udało się pobrać danych użytkownika', error.status.toString(), {
              duration: 2000
            });
          });
        }
      });
    } else {
      const exists = this.userFormArray.some((user: FormGroup) => user.get('usersUuid')?.value === usersUuid);

      if (exists) {
        // this.snack.open('Wybrany użytkownik już jest dodany', '', {
        //   duration: 2000
        // });
        this.updateUsersFormArray();
        return;
      }
      this.userFormArray.push(this.fb.group({
        usersUuid: this.fb.control(usersUuid || '', [Validators.required]),
        usersName:  this.fb.control(usersName || '', [Validators.required]),
        usersPosition:  this.fb.control(usersPosition || ''),
        usersPhone:  this.fb.control(usersPhone || '', [Validators.required, validPhoneNumber()]),
        usersEmail: this.fb.control(usersEmail || '', [Validators.required,  validEmailAddress()]),
      }));
    }
    this.updateUsersFormArray();
  }

  updateUsersFormArray(): void {
    this.postForm.setControl('users', this.fb.array( this.userFormArray));
  }

  removeUsers(index: number): void {
    this.userFormArray.splice(index, 1);
    this.updateUsersFormArray();
  }

  downloadAttachmentFile(fileLocation: string, fileName: string): void {
    this.postService.downloadAttachmentFile(fileLocation, fileName);
  }

}
